module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "clickoutside",
      rawName: "v-clickoutside",
      value: (_vm.handleBlur),
      expression: "handleBlur"
    }],
    staticClass: "el-autocomplete"
  }, [_c('el-input', {
    attrs: {
      "value": _vm.value,
      "disabled": _vm.disabled,
      "placeholder": _vm.placeholder,
      "name": _vm.name,
      "size": _vm.size
    },
    on: {
      "change": _vm.handleChange,
      "focus": _vm.handleFocus
    },
    nativeOn: {
      "keydown": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "up", 38)) { return null; }
        _vm.highlight(_vm.highlightedIndex - 1)
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "down", 40)) { return null; }
        _vm.highlight(_vm.highlightedIndex + 1)
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.select(_vm.highlightedIndex)
      }]
    }
  }, [(_vm.$slots.prepend) ? _c('template', {
    slot: "prepend"
  }, [_vm._t("prepend")], 2) : _vm._e(), _vm._v(" "), (_vm.$slots.append) ? _c('template', {
    slot: "append"
  }, [_vm._t("append")], 2) : _vm._e()], 2), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "md-fade-bottom"
    }
  }, [(_vm.suggestionVisible) ? _c('ul', {
    ref: "suggestions",
    staticClass: "el-autocomplete-suggestions",
    class: {
      'is-loading': _vm.loading
    }
  }, [(_vm.loading) ? _c('li', [_c('i', {
    staticClass: "el-icon-loading"
  })]) : _vm._l((_vm.suggestions), function(item, index) {
    return [(!_vm.customItem) ? _c('li', {
      class: {
        'highlighted': _vm.highlightedIndex === index
      },
      on: {
        "click": function($event) {
          _vm.select(index)
        }
      }
    }, [_vm._v("\n                    " + _vm._s(item.value) + "\n                ")]) : _c(_vm.customItem, {
      tag: "component",
      class: {
        'highlighted': _vm.highlightedIndex === index
      },
      attrs: {
        "item": item,
        "index": index
      },
      on: {
        "click": function($event) {
          _vm.select(index)
        }
      }
    })]
  })], 2) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-fd99fd5a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/autocomplete/src/autocomplete.vue
// module id = 686
// module chunks = 0